import { differenceInWeeks } from 'date-fns';
import { ProductItemPreviewProps } from 'store/product/types';

export const RECENTLY_VIEWED_KEY = 'recently_viewed';
const MAX_STORED = 30;

const recentlyViewedUtil = () => {
  const getStored = (): ProductItemPreviewProps[] => {
    const stored = localStorage.getItem(RECENTLY_VIEWED_KEY) || '[]';
    const parsed = JSON.parse(stored) || [];
    return Array.isArray(parsed) ? parsed : [];
  };

  const setStored = (items: ProductItemPreviewProps[]) => {
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(items));
  };

  const storeRecentlyViewed = (item: ProductItemPreviewProps) => {
    const items = [item, ...getStored().filter((i) => i.uniqueProductId !== item.uniqueProductId)].slice(
      0,
      MAX_STORED - 1,
    );
    setStored(items);
  };

  const clearRecentlyViewed = () => {
    setStored([]);
  };

  return {
    clearRecentlyViewed,
    storeRecentlyViewed,
    getStored,
  };
};

export default recentlyViewedUtil;
